import React, {useContext} from 'react'
import {useParams} from 'react-router-dom'
import {WindowPopup} from "../components/WindowPopup"
import config from "../config.json"
import {
    getAuthHeader,
    getItems,
    getLocalStorageItem,
    objectLang,
    removeCookieOfFolderId,
    setLocalStorageItem
} from "../functions"
import {AuthContext} from "../context/AuthContext"
import {useHttp} from "../hooks/http.hook"
import {LoaderClass} from "../elements/LoaderClass"
import {LinksClass} from "../components/LinksClass";

export const GoogleDriveRenamePage = () => {
    setLocalStorageItem('page', 'GoogleDriveRenamePage')

    const lang = objectLang().language

    const host =
        window.location.host === 'localhost:3000'
            ? config.localHost
            : config.onrender

    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()

    const { fileId } = useParams()
    const data = {
        fileId,
        oldName: new URLSearchParams(window.location.search).get('name') || '',
        typeData: 'google-rename',
        thumb: new URLSearchParams(window.location.search).get('thumb') || '',
        fileType: new URLSearchParams(window.location.search).get('item') || '',
        link: {from: new URLSearchParams(window.location.search).get('from') || 'us-link.cloud'}
    }
    const parent = new URLSearchParams(window.location.search).get('parent') || 'root'

    const onRename = async (name) => {
        if (!name) return
        try {
            await request(
                `${host}/api/google-drive/rename`,
                'POST',
                {
                    fileId: fileId,
                    name: name,
                    redirectURI: window.location.origin
                },
                {
                    Authorization: getAuthHeader(auth),
                    'Content-Type': 'application/json'
                })

            removeCookieOfFolderId(parent)
            window.location.replace(`/${lang.lang}/google-drive/open/${parent}`)

        } catch (e) {
            window.location.replace(`/${lang.lang}/`)
        }
    }

    if (loading) {
        return <LoaderClass />
    }

    return (
        <>
            <LinksClass
                auth={auth}
                documents={getLocalStorageItem('documents')}
                items={getItems(getLocalStorageItem('documents'))}
                rootFolder={auth.rootFolder}
            />
            {data && (
                <WindowPopup data={data} lang={lang} title={lang.body.googleRenamePage.title} onRename={onRename} />
            )}
        </>
    )
}